export const customStyles = {
  day_label: {
    color: '#000000',
    fontFamily: 'Poppins',
  },
  month: {
    borderWidth: 0,
  },
  month_label: {
    color: '#000000',
    fontFamily: 'Poppins',
    fontWeight: 500,
  },
  selected_month: {
    backgroundColor: '#94A3B8'
  },
  selected_month_label: {
    color: '#FFFFFF',
    fontFamily: 'Poppins',
  },
  year: {
    borderWidth: 0,
  },
  year_label: {
    color: '#000000',
    fontFamily: 'Poppins',
    fontWeight: 500,
  },
  selected_year: {
    backgroundColor: '#94A3B8'
  },
  selected_year_label: {
    color: '#FFFFFF',
    fontFamily: 'Poppins',
  },
  month_selector_label: {
    color: '#000000',
    fontFamily: 'Poppins',
    fontWeight: 700,
  },
  year_selector_label: {
    color: '#000000',
    fontFamily: 'Poppins',
    fontWeight: 700,
  },
  weekday_label: {
    color: '#000000',
    fontFamily: 'Poppins',
    fontWeight: 700,
  },
  today: {
    backgroundColor: '#CCCCCC'
  },
  selected: {
    backgroundColor: '#3B82F6'
  },
  selected_label: {
    color: '#FFFFFF',
    fontFamily: 'Poppins',
  },
  button_next_image: {
    opacity: 1,
    filter: 'none',
  },
  button_prev_image: {
    opacity: 1,
    filter: 'none',
  },
  button_next: {
    opacity: 1,
    filter: 'none',
  },
  button_prev: {
    opacity: 1,
    filter: 'none',
  }
};

export const modalStyles = {
	datepickerOverlay: {
	  flex: 1,
	  backgroundColor: 'rgba(0, 0, 0, 0.5)',
	  justifyContent: 'center',
	  alignItems: 'center',
	  padding: 20,
	},
	datepickerContainer: {
	  backgroundColor: '#FFFFFF',
	  borderRadius: 12,
	  width: '100%',
	  maxWidth: 400,
	  overflow: 'hidden',
	  elevation: 5,
	  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
	  cursor: 'default',
	},
	datepickerBody: {
	  padding: 20,
	},
	datepickerFooter: {
	  padding: 20,
	  paddingTop: 0,
	  flexDirection: 'row-reverse',
	  justifyContent: 'space-between',
	},
	datepickerCancelButton: {
	  fontFamily: 'Poppins',
	  fontSize: 16,
	  color: '#000000'
	},
}